import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import Container from 'common/Container';
import { useTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const ANCHOR_IMAGE = 'https://files.tnonetwork.com/users/profile/carolinahernandez.jpg';

const Who = ({ themeMode = 'light' }) => {
  const theme = useTheme();
  return (
    <Box>
      <Box marginBottom={4}>
        <Container
          sx={{
            backgroundImage: themeMode === 'dark' ? 'url(/images/logos/logo_white.PNG)' : 'url(/images/logos/logo_tnonetwork_black.png)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
            height: '20vh',
          }}
        />
        <Box
          component={Typography}
          fontWeight={700}
          variant={'h3'}
          gutterBottom
          align={'center'}
          color={theme.palette.primary.main}
        >
          Vida Inmobiliaria: mercado, tendencias y decisiones inteligentes sobre tu patrimonio
        </Box>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
        >
          El espacio de TNO Network para compradores, inversionistas, desarrolladores y familias que buscan información clara sobre bienes raíces en Venezuela y la región. Tu marca junto a conversaciones que mueven el sector.
        </Typography>
        <Typography
          variant={'h5'}
          component={'p'}
          color={theme.palette.primary.main}
          align={'center'}
          sx={{ mt: 3, mb: 2, fontStyle: 'italic' }}
        >
          ¿Qué es Vida Inmobiliaria?
        </Typography>
        <Typography align="center" sx={{ mb: 1 }}>
          <Link
            href="https://tnonetwork.com/show/vidainmobiliaria"
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
            underline="hover"
          >
            tnonetwork.com/show/vidainmobiliaria
          </Link>
        </Typography>
        <Typography
          variant={'body1'}
          component={'p'}
          color={'textSecondary'}
          align={'center'}
          sx={{ mt: 1 }}
        >
          Programa del nicho inmobiliario y comunidad en TNO Network: entrevistas con expertos, análisis de mercado, financiamiento, proyectos, alquiler y plusvalía. Formato en vivo, On-Demand y presencia en el ecosistema digital TNO.
        </Typography>
      </Box>

      <Box marginTop={6} marginBottom={4}>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={3}>
            <Box display="flex" justifyContent="center">
              <Box
                component="img"
                src={ANCHOR_IMAGE}
                alt="Carolina Hernández - Ancla de Vida Inmobiliaria"
                sx={{
                  width: { xs: 200, sm: 250, md: 300 },
                  height: { xs: 200, sm: 250, md: 300 },
                  borderRadius: 2,
                  objectFit: 'cover',
                  objectPosition: 'center top',
                  boxShadow: 3,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography
              variant={'h5'}
              fontWeight={700}
              gutterBottom
              color={theme.palette.primary.main}
            >
              NUESTRA ANCLA: CAROLINA HERNÁNDEZ
            </Typography>
            <Typography
              variant={'body2'}
              color={'textSecondary'}
              sx={{ fontStyle: 'italic', mb: 2 }}
            >
              La voz que conecta mercado inmobiliario, inversión y decisiones patrimoniales
            </Typography>
            <Typography variant={'body1'} color={'textSecondary'}>
              <strong>Carolina Hernández</strong> conduce <strong>Vida Inmobiliaria</strong> en TNO Network. Con entrevistas a expertos y análisis claro del sector, orienta a la audiencia en compra, venta, financiamiento y plusvalía. Ideal para inmobiliarias, constructoras, bancos, seguros y marcas del ecosistema hogar.
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

Who.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Who;
